import React from 'react';
import AssignmentItem from '../Domain/AssignmentItem';
import EvaluatorAssignmentItem from '../Domain/EvaluatorAssignmentItem';
import LocationAssignmentItem from '../Domain/LocationAssignmentItem';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService.js';
import OpenAssignmentItem from '../Domain/OpenAssignmentItem';
import MyOfficeAssignmentSummaryItem from '../Domain/MyOfficeAssignmentSummaryItem.js';
import MyOfficeAssignmentDetailItem from '../Domain/MyOfficeAssignmentDetailItem.js';
import MyOfficeAssignmentItem from '../Domain/MyOfficeAssignmentItem.js';
import SearchParams from '../Elements/SearchParams';
import AssignmentSearchParams from '../Contents/Operations/Assignments/AssignmentSearchParams';
import OpenAssignmentSearchParams from '../Contents/Operations/Assignments/OpenAssignments/OpenAssignmentSearchParams';
import MyOfficeAssignmentSummarySearchParams from '../Contents/Operations/Assignments/MyOfficeAssignment/MyOfficeAssignmentSummarySearchParams';
import MyOfficeAssignmentSearchParams from '../Contents/Operations/Assignments/MyOfficeAssignment/MyOfficeAssignmentSearchParams';

export default class AssignmentService extends React.Component {
  static GetAssignmentList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    searchItem.SelectedFieldworkOfficeIds = searchItem.SelectedFieldworkOfficeIds.toString();
    const searchParams = new SearchParams(searchItem, AssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAllBySearchingAsync?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static GetEvaluatorAssignmentList(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, AssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAllEvaluatorAssignmentsBySearchingAsync?&searchParams=${searchParams.serializeForBackendCall()}`
    );
  }

  static GetAssignmentExtendedList(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAllBySearchingExtendedAsync?&searchParams=${JSON.stringify(searchParams)}`
    );
  }

  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const authService = AuthService.getInstance();

    let url = '/api/Assignment/GetAllBySearchingAsync/?';

    let paramsStarted = false;

    if (searchItem) {
      url += `searchItem=${JSON.stringify(searchItem)}`;
      paramsStarted = true;
    }

    if (orderById) {
      url += paramsStarted ? '&' : '';
      url += `orderById=${orderById}`;
      paramsStarted = true;
    }

    if (orderDir) {
      url += paramsStarted ? '&' : '';
      url += `orderDir=${orderDir}`;
      paramsStarted = true;
    }

    if (pageNumber) {
      url += paramsStarted ? '&' : '';
      url += `pageNumber=${pageNumber}`;
      paramsStarted = true;
    }

    if (numberOfElements) {
      url += paramsStarted ? '&' : '';
      url += `numberOfElements=${numberOfElements}`;
      paramsStarted = true;
    }

    return authService.CallBackendFunction(url);
  }

  static GetAssignmentById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/Assignment/GetAssignmentById/${id}?clearCache=false`);
  }

  static GetAssignmentListByClientUnitId(clientUnitId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetAssignmentListByClientUnitId/${clientUnitId}`
    );
  }

  static ConvertDBItemList(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new AssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertDBItemListEvaluator(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new EvaluatorAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertDBItemListLocation(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new LocationAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static EditAssignment(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);
    const url = '/api/Assignment/EditAssignment';

    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(item));
  }

  static GetOpenAssignmentListBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, OpenAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/VOpenAssignmentList/GetOpenAssignmentsBySearchingAsync/?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertOpenAssignmentDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OpenAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetMyOfficeAssignmentSummaryBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, MyOfficeAssignmentSummarySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetMyOfficeAssignmentSummaryAsync/?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertMyOfficeAssignmentSummaryDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new MyOfficeAssignmentSummaryItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetMyOfficeAssignmentDetailsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, MyOfficeAssignmentSummarySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetMyOfficeAssignmentDetailsAsync/?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertMyOfficeAssignmentDetailDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new MyOfficeAssignmentDetailItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetMyOfficeAssignmentsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, MyOfficeAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    return AuthService.getInstance().CallBackendFunction(
      `/api/Assignment/GetMyOfficeAssignmentsAsync/?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertMyOfficeAssignmentDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new MyOfficeAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}
